import { Sysappfields, Sysappbuttons, ParentBusiness } from "fccore2";
import { GrandComponent } from "./grand.component";
import { FCEVENT } from "./fc";
import { FCCONFIG } from "fccore2";
import { FcEvent } from "./business/fcevent.event";
import { ViewChild } from "@angular/core";
import { FclistdataComponent } from "./fclist/fclistdata.component";
import { CacheService } from "fccore2";
import { CommonService } from "fccore2";
export abstract class ParentlistComponent extends GrandComponent {
  // é»è®¤éç¨çæ¯å¦å¯ç¨æ¥è¯¢
  enableAutoSearch: boolean;
  //åè¡¨çæ°æ®éå
  pageList: any[];
  /** ä¿®æ¹å¯¹è±¡éåï¼å¨åè¡¨æ¹éä¿®æ¹æ¶ææ*/
  modifyObjs: any[];
  /**æ¡ä»¶åå®¹,å­ç¬¦ä¸²ï¼å¿é¡»ç¬¦åjsonæ ¼å¼çå­ç¬¦ä¸²ï¼å½æ­¤å­ç¬¦ä¸²çå¼åçååçæ¶åï¼èªå¨å·æ°åè¡¨ã*/
  condition: string;
  /**æ¥è¯¢æ¡ä»¶å¯¹è±¡åå®¹ï¼ææçæ¥è¯¢æ¡ä»¶ç»å®å¨æ­¤å¯¹è±¡ä¸­ã*/
  searchObj: any;
  /** å¨åè¡¨ä¸­éä¸­è®°å½ï¼æ¯åä¸ªå¯¹è±¡*/
  selectedObject: any;
  /** éä¸­çææè®°å½åï¼æ¯éåå¯¹è±¡*/
  selectedObjects: any[];
  /**é»è®¤çæåºå­æ®µ*/
  orderBy: string;
  /**åé¡µæ»æ°*/
  pageTotal: number;
  /**åé¡µç´¢å¼*/
  pageNum: number;
  /**åé¡µå¤§å°*/
  pageSize: number;
  /**åè¡¨å­æ®µéå*/
  mainFields: Sysappfields[];
  /**å·¥å·æ */
  mainToolbar: Sysappbuttons[];
  /**åè¡¨æä½æé®*/
  mainListButtons: Sysappbuttons[];
  /**å­åè¡¨ç»ä»¶*/
  @ViewChild(FclistdataComponent, { static: false })
  listWnd: FclistdataComponent;

  /**
   * æ ¹æ®æ¨¡ååäº§åidåå§åç¶ç±»,å½æ­¤ç±»ä¸å·æmidï¼åæ¨¡åidçæ¶åï¼å¯ä»¥ä¸ä¼ 
   * @param pid äº§åid
   * @param aid æ¨¡åid
   */
  constructor(pid?: string, aid?: string) {
    /** ç¶ç±»çåå§å*/
    super(pid, aid);
  }

  /**
   * åå§åå½åå¯¹è±¡åå®¹
   */
  _init() {
    /** å¨åè¡¨ä¸­éä¸­è®°å½ï¼æ¯åä¸ªå¯¹è±¡*/
    this.selectedObject = {};
    /** éä¸­çææè®°å½åï¼æ¯éåå¯¹è±¡*/
    this.selectedObjects = [];
    /**åå§åæ¥è¯¢æ¡ä»¶*/
    this.searchObj = {};
    // ä¿®æ¹å¯¹è±¡
    this.modifyObjs = [];
    /**åè¡¨çæ°æ®éå*/
    this.pageList = [];
    /** é»è®¤ä¸ºç¬¬ä¸é¡µ*/
    this.pageNum = 1;
    /** é»è®¤ä¸ºå½åæ¨¡åçåé¡µæ°*/
    this.pageSize = this.mainApp
      ? this.mainApp.PSIZE
        ? this.mainApp.PSIZE
        : 20
      : 20;
    /** å½åå*/
    this.mainFields = this.mainApp
      ? ParentBusiness.appService.getListFieldsByApp(this.mainApp)
      : [];
    /** å½ååæé®*/
    this.mainListButtons = this.mainApp
      ? ParentBusiness.appService.getListButtonsByApp(this.mainApp)
      : [];
    /** æ»é¡µæ°*/
    this.pageTotal = 0;
    /** é»è®¤å¯ç¨èªå¨æ¥è¯¢*/
    this.enableAutoSearch = true;
    // å­ç±»åå§å
    this.init();
  }

  ngOnInit() {
    /**åå§åæ¥è¯¢æ¡ä»¶*/
    this.searchObj = {};
    /** åå§åæ¥è¯¢æ¡ä»¶*/
    this._initCondition();
    /** æ§è¡æ¥è¯¢äºä»¶*/
    this.search();
  }
  /**
   * åå§åæ¡ä»¶
   */
  private _initCondition() {
    this.condition = JSON.stringify(
      ParentBusiness.appService.initObjDefaultConditon(this.mainApp)
    );
  }

  /**
   * å­ç±»åå§å
   */
  abstract init(): void;

  /**
   * å­ç±»é»è®¤è°ç¨å¯¹è±¡
   */
  private query(): void {
    let condition: any = {};
    if (this.condition && this.condition.length > 2) {
      condition.WHERE = this.condition;
    }
    condition.PAGESIZE = this.pageSize;
    condition.PAGENUM = this.pageNum;
    condition.ORDER = this.orderBy || "";
    this.condition = condition;
    // ç¼å­æ¥è¯¢æ¡ä»¶
    // CacheService.set(this.moduleId + this.appId + "SEARCHOBJ", this.searchObj);
    if (this.enableAutoSearch) {
      this.pushDestroy(
        ParentBusiness.appService
          .findWithQuery(this.appId, condition)
          .subscribe(result => {
            if (result.CODE === "0") {
              this.pageList = result.DATA;
              this.pageTotal = result.TOTALSIZE;
            }
          })
      );
    }
  }

  /**
   * è·åé»è®¤çæ¥è¯¢æ¡ä»¶
   */
  abstract getDefaultQuery(): any;

  /**
   * æ¥è¯¢éç½®
   **/
  reset() {
    /** å­ç±»æ¥è¯¢æ¡ä»¶åå§å*/
    if (this.searchObj && Object.keys(this.searchObj).length > 0) {
      Object.keys(this.searchObj).forEach(key => {
        this.searchObj[key] = "";
      });
    }
    this.search();
  }
  /**
   * æ¥è¯¢æ¡ä»¶ååçæ¶åè°ç¨
   */
  public searchObjModelChange(key, value): void {
    if (key) {
      let obj: any = {};
      obj[key] = value || "";
      this.search({ eventName: "search", param: obj });
    } else {
      this.search();
    }
  }
  /**
   * è·åæ¥è¯¢æ¡ä»¶åå®¹
   * @param event
   */
  public search(event?: FCEVENT): any {
    if (event) {
      this.searchObj = Object.assign(this.searchObj, event.param);
    }
    let _condition: any = {};
    /** å¤æ­æ¯å¦å­å¨æ¥è¯¢æ¡ä»¶åå®¹*/
    if (typeof this.searchObj === "object") {
      Object.keys(this.searchObj).forEach(key => {
        if (this.searchObj[key] && this.searchObj[key] !== "") {
          _condition[key] = { like: "%" + this.searchObj[key] + "%" };
        }
      });
    }
    /**   è·åé»è®¤æ¥è¯¢æ¡ä»¶æèªå®ä¹çæ¥è¯¢likeç­*/
    let defautlSearchObj = Object.assign(this.getDefaultQuery(), _condition);
    this.condition = JSON.stringify(defautlSearchObj);
    this.query();
  }

  /**
   * åé¡µäºä»¶ äºä»¶åç§°ï¼param
   * @param event {eventName:,param:}
   */
  pageQuery(event: FCEVENT): void {
    switch (event.eventName) {
      case "pageSizeChange" /**æ¯é¡µæ¾ç¤ºå¤å°æ¡*/:
        this.pageSize = event.param;
        this.pageNum = 1;
        break;
      case "jumpPage" /**è·³è½¬å°ç¬¬å é¡µ*/:
        this.pageNum = event.param;
        break;
    }
    this.query();
  }

  /**
   * å é¤ä¹åçæä½
   * @param mainObj
   */
  beforeDelete(mainObj: any): boolean {
    return true;
  }

  /**
   * å é¤ä¹åçæä½
   */
  afterDelete(): void {}

  /**
   * åè¡¨æ°å¢
   * @param event
   */
  public listAdd(event?: FCEVENT): void {
    this.navigateAdd({ refresh: "Y", MENUICON: this.routerParam.MENUICON });
  }

  /**
   * åè¡¨ç¼è¾
   * @param event
   */
  public listEdit(event: FCEVENT): void {
    if (this.selectedObjects && this.selectedObjects.length == 1) {
      if (this.beforeEdit()) {
        this.navigateModify({
          eventName: event.eventName,
          param: this.selectedObject
        });
      }
    } else {
      ParentBusiness.msgService.warm("è¯·éæ©ä¸æ¡è®°å½ï¼");
      return;
    }
  }

  /**
   * åè¡¨ç¼è¾
   * @param event
   */
  public listOneEdit(event: FCEVENT): void {
    if (this.beforeEdit()) {
      this.navigateModify(event);
    }
  }

  /**
   * ç¼è¾ä¹åçæä½
   */
  beforeEdit(): boolean {
    return true;
  }

  /**
   * å é¤ä¸æ¡è®°å½
   * @param context
   */
  listOneDelete(context: any): void {
    CommonService.event(FcEvent.fcmodal.confirm, {
      title: "ç¡®è®¤å é¤è®°å½åï¼",
      okFunc: () => {
        let mainObj = context.param;
        if (this.beforeDelete(mainObj)) {
          this.pushDestroy(
            ParentBusiness.appService
              .deleteObject(this.mainApp.APPID, mainObj.ID)
              .subscribe(result => {
                if (result.CODE === "0") {
                  this.afterDelete();
                  ParentBusiness.msgService.message("å é¤æåï¼");
                  /** this.listWnd.deleteRowDataById([mainObj.ID]);*/
                  this.search();
                } else {
                  ParentBusiness.msgService.message("å é¤å¤±è´¥ï¼");
                }
              })
          );
        }
      },
      cancelFunc: () => {}
    });
    /**é»æ­¢åæ³¡*/
    event.stopPropagation();
    event.preventDefault();
  }

  /**
   * åè¡¨æ¹éå é¤
   * @param event
   */
  listDelete(event: FCEVENT): void {
    if (this.selectedObjects.length === 0) {
      ParentBusiness.msgService.warm("è¯·éæ©è³å°ä¸æ¡è®°å½ï¼");
      return;
    }
    let canDo = true;
    for (let i = 0; i < this.selectedObjects.length; i++) {
      let mainObj = this.selectedObjects[i];
      if (!this.beforeDelete(mainObj)) {
        canDo = false;
        break;
      }
    }
    if (!canDo) {
      return;
    }
    let ids = [];
    this.selectedObjects.forEach(obj => {
      ids.push({ ID: obj.ID });
    });
    CommonService.event(FcEvent.fcmodal.confirm, {
      title: "ç¡®è®¤å é¤è®°å½åï¼",
      okFunc: () => {
        this.pushDestroy(
          ParentBusiness.appService
            .deleteObjects(this.mainApp.APPID, ids)
            .subscribe(result => {
              if (result.CODE === "0") {
                this.afterDelete();
                this.selectedObjects.forEach(obj => {
                  /** this.listWnd.deleteRowDataById([obj.ID]);*/
                });
                ParentBusiness.msgService.message("å é¤æåï¼");
              } else {
                ParentBusiness.msgService.message("å é¤å¤±è´¥ï¼");
              }
            })
        );
      },
      cancelFunc: () => {}
    });
  }

  /**
   * åè¡¨å¸®å©
   * @param action
   */
  listHelp(action: string): void {}

  /**
   * åè¡¨å¯¼å¥
   * @param action
   */
  import(action: string): void {}

  /**
   * åè¡¨å¯¼åº
   * @param action
   */
  export(action: string): void {
    let selectObjs = this.selectedObjects;
    let where = undefined;
    if (selectObjs && selectObjs.length > 0) {
      where = "AND ID in (";
      selectObjs.forEach(obj => {
        where += "'" + obj.ID + "',";
      });
      where += "'')";
    }
    if (where === undefined) {
      window.open(FCCONFIG.apiurl + this.moduleId + "/SYSRESLIB/EXPORTEXCEL");
    } else {
      window.open(
        FCCONFIG.apiurl +
          this.moduleId +
          "/SYSRESLIB/EXPORTEXCEL?WHERE=" +
          encodeURIComponent(where)
      );
    }
    //      this.mainService.providers.daoService.getFromApi(this.mainService
    //   let a = result;
    //      });
    //     // å¦ææ²¡æéä¸­æ°æ®ï¼ä»åç«¯ååºå¯¼åºæ°æ®
    //     let datas: any[] = this.mainService.commonService.cloneArray(thi
    //     let data: any[] = [];
    //     /let header: string[] = [];
    //     this.mainFields.forEach(field => {
    //     header.push(field.FIELDNAME);
    //     });
    //     data.push(header);
    // //    å¦æéä¸­æ°æ®ï¼å¯¼åºå·²éä¸­çæ°æ®
    //     if (select.length !== 0) datas = select;
    //      datas.forEach(row => {
    //       let obj: any[] = [];
    //         this.mainFields.forEach(field => {
    //            if (row[field.FIELDCODE + '_DICDESC']) {
    //                obj.push(row[field.FIELDCODE + '_DICDESC']);
    //            } else {
    //               obj.push(row[field.FIELDCODE]);*/
    //            }
    //         });
    //       data.push(obj);
    //    })*/
    //      generate worksheet */
    //     const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    //     generate workbook and add the worksheet
    //      const wb: XLSX.WorkBook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, this.mainApp.APPNAME);
    //     save to file
    //     XLSX.writeFile(wb, this.mainApp.APPNAME + this.mainService.commo
  }

  /**
   * åè¡¨å·¥å·æ å¤çäºä»¶
   * @param event äºä»¶åç§°
   */
  tlblistEvent(event: FCEVENT) {
    switch (event.eventName) {
      case "listAdd":
        this.listAdd(event);
        break;
      case "listDelete":
        this.listDelete(event);
        break;
      case "listEdit":
        this.listEdit(event);
        break;
      case "listHelp":
        this.listHelp(event.eventName);
        break;
      case "importexcel":
        this.import(event.eventName);
        break;
      case "exportexcel":
        this.export(event.eventName);
        break;
      default:
        this.event(event.eventName, event);
    }
  }

  /**
   * æ¥è¯¢äºä»¶å¤ç
   * @param event æ¥è¯¢äºä»¶åæ°
   */
  searchlistEvent(event: FCEVENT): void {
    switch (event.eventName) {
      case "search":
        this.search();
        break;
      default:
        this.event(event.eventName, event.param);
    }
  }

  /**
   * èªå®ä¹äºä»¶åç§°
   * @param eventName äºä»¶åç§°
   * @param context ä¸ä¸åç¯å¢
   */
  abstract event(eventName: string, context: any): void;

  /**
   * è·³è½¬è³æ°å¢é¡µé¢
   * @param params è·¯ç±åæ°
   */
  navigateAdd(params?: any) {
    if (!params) {
      params = { refresh: "Y" };
    } else {
      params.refresh = "Y";
    }
    this.navigate(this.getRouteUrl("Edit"), params);
  }

  /**
   * è·³è½¬è³ä¿®æ¹é¡µé¢
   * @param event å½åäºä»¶å¥æ
   * @return promise
   */
  navigateModify(event: FCEVENT): Promise<any> {
    CacheService.setS(
      this.appId + "DATA",
      CommonService.cloneArray([event.param], "DOACTION")
    );
    return this.navigate(this.getRouteUrl("Edit"), {
      ID: event.param.ID,
      refresh: "Y",
      MENUICON: this.routerParam.MENUICON
    });
  }

  /**
   * è·³è½¬è³è¯¦æé¡µé¢
   * @param event å½åäºä»¶å¥æ
   * @return promise
   */
  navigateDetail(event: FCEVENT): Promise<any> {
    CacheService.setS(
      this.appId + "DATA",
      CommonService.cloneArray([event.param], "DOACTION")
    );
    return this.navigate(this.getRouteUrl("Detail"), {
      ID: event.param.ID,
      refresh: "Y"
    }).catch(() => {
      return this.navigateModify(event);
    });
  }

  /**
   * ååæ ¼éä¸­
   * @param event
   */
  cellClick(event: FCEVENT) {
    if (event.param.field.INPUTTYPE && event.param.field.INPUTTYPE === "url") {
      window.open(event.param.data[event.param.field.FIELDCODE], "_blank");
    }
  }

  /**
   * æ ¹æ®åè¡¨å¤çäºä»¶
   * @param action äºä»¶åç§°
   */
  listdataEvent(event: FCEVENT) {
    switch (event.eventName) {
      case "listOneEdit":
        this.listOneEdit(event);
        break;
      case "listOneDelete":
        this.listOneDelete(event);
        break;
      case "listOneView":
        this.navigateDetail(event);
        break;
      case "cellClick":
        this.cellClick(event);
        break;
      case "rowClick":
        break;
      case "selected":
        this.onSelect(event);
        break;
      case "modify":
        this.onModify(event);
        break;
      case "pageSizeChange":
        this.pageSizeChange(event);
        break;
      case "jumpPage":
        this.jumpPage(event);
        break;
      default:
        this.tlblistEvent(event);
    }
  }
  /**
   * é¡µé¢sizeæ¹å
   * @param event
   */
  pageSizeChange(event: FCEVENT): void {
    this.pageSize = event.param;
  }
  /**
   * è·³è½¬è³é¡µé¢
   * @param event
   */
  jumpPage(event: FCEVENT): void {
    this.pageNum = event.param;
  }
  /**
   * éä¸­çæ°æ®å¯¹è±¡ååé
   * @param event
   */
  onSelect(event: FCEVENT) {
    this.selectedObjects = event.param;
    if (this.selectedObjects.length > 0) {
      this.selectedObject = this.selectedObjects[0];
    }
  }

  /**
   * å¨åè¡¨ä¸­ç¼è¾æ°æ®å¯¹è±¡æ¾å¥ç¼è¾å¯¹è±¡ä¸­
   * @param event
   */
  onModify(event: FCEVENT) {
    this.modifyObjs.push(event.param);
  }

  /**
   * ç¹èµ
   * @param event
   */
  thumbUp(event: any): void {
    ParentBusiness.msgService.message("ç¹èµåè½æ­£å¨å¼åä¸­ï¼æ¬è¯·æå¾ï¼");
    /**é»æ­¢åæ³¡*/
    this.stopPropagation(event);
  }

  /**
   * ä¸è½½
   * @param event
   */
  download(event: any): void {
    ParentBusiness.msgService.message("ä¸è½½åè½æ­£å¨å¼åä¸­ï¼æ¬è¯·æå¾ï¼");
    /**é»æ­¢åæ³¡*/
    this.stopPropagation(event);
  }

  /**
   * è¯è®º
   * @param event
   */
  evaluate(event: any): void {
    ParentBusiness.msgService.message("è¯è®ºåè½æ­£å¨å¼åä¸­ï¼æ¬è¯·æå¾ï¼");
    /**é»æ­¢åæ³¡*/
    this.stopPropagation(event);
  }

  /**
   * ç»è®¡
   * @param event
   */
  count(event: any): void {
    ParentBusiness.msgService.message("ç»è®¡åè½æ­£å¨å¼åä¸­ï¼æ¬è¯·æå¾ï¼");
    /**é»æ­¢åæ³¡*/
    this.stopPropagation(event);
  }
}
